
let timeInterval;
jQuery(document).ready(function() {
const $ = jQuery;

const countDown = () => {
  let dateNow;
  let dateEven;
  let diffTime;

  jQuery.each(jQuery('.count-down input'), function (index, input) {
  timeInterval = setInterval(() => { 
    dateNow = moment(Number(Date.now())).local();
    let dateEvent = moment(Number(input.value * 1000)).local();
    let diffTime = moment.duration(dateEvent.diff(dateNow));
  
    // Math.floor(diffTime.asDays())

    // $(`.months-${index}`).text(diffTime.months());
    $(`.days-${index}`).text(diffTime.months() > 0 ? Math.floor(diffTime.asDays()) : diffTime.days());
    $(`.hours-${index}`).text(diffTime.hours());
    $(`.minutes-${index}`).text(diffTime.minutes());
    $(`.seconds-${index}`).text(diffTime.seconds());




    // console.log(
    //   {
    //   months: diffTime.months(),
    //   // months: diffTime.year(),
    //   days: diffTime.days(),
    //   hours: diffTime.hours(),
    //   minutes: diffTime.minutes(), 
    //   second: diffTime.seconds(),
    //   interval: timeInterval,
    //   dateNow: dateNow,
    //   dateEvent: dateEvent
    // }
    //   ); 
    }, 1000)
})

}
countDown();
})

